var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreBoundryIcnRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#e33745"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1537 17.6727H11.077V13.9805C11.4615 13.9805 11.7884 13.8459 12.0578 13.5767C12.3269 13.3074 12.4615 12.9805 12.4615 12.596V9.82674H11.5385V12.596H11.077V9.82674H10.1537V12.596H9.69225V9.82674H8.76925V12.596C8.76925 12.9805 8.90383 13.3074 9.173 13.5767C9.44233 13.8459 9.76925 13.9805 10.1537 13.9805V17.6727ZM13.8462 17.6727H14.7693V9.82674C14.2641 9.82674 13.8301 10.0075 13.4672 10.369C13.1044 10.7305 12.923 11.1651 12.923 11.6727V14.442H13.8462V17.6727ZM4.5 20.4997V9.24973L12 3.61523L19.5 9.24973V20.4997H4.5ZM6 18.9997H18V9.99973L12 5.49973L6 9.99973V18.9997Z",
    fill: "#e33745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreBoundryIcnRed);
export default __webpack_public_path__ + "static/media/preBoundryIcnRed.91e5816fd440ec5eb20b57b9adb86915.svg";
export { ForwardRef as ReactComponent };